import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

import { selectInvoiceStatuses } from '~lookups/selectors/invoiceStatuses';

export const searchFields: SearchProps = {
  invoice_reference: {
    defaultShow: true,
    type: 'text-like',
    field: 'reference',
    placeholder: 'Invoice Reference',
    caption: 'Invoice Reference',
  },
  client: {
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname', 'full_name'],
    placeholder: 'Client Name',
    caption: 'Client',
  },
  supplier: {
    defaultShow: false,
    type: 'text-like',
    field: 'supplier.name',
    placeholder: 'Supplier',
    caption: 'Supplier',
  },
  invoice_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'invoice_date',
    caption: 'Invoice Date',
  },

  due_date: {
    defaultShow: false,
    type: 'date-range',
    field: 'due_date',
    caption: 'Due Date',
  },
  status: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'status_id',
    placeholder: 'All',
    caption: 'Status',
    selectorOptions: selectInvoiceStatuses,
  },
  requires_senior_approval: {
    defaultShow: true,
    type: 'lookup',
    field: 'requires_senior_approval',
    caption: 'Senior Approval Required?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
};

export default searchFields;
